/*
 * Copyright (c) 2022. American Express Company
 */

export abstract class TLElement {
    public abstract create(): void;
    public abstract updateX(): void;
    public abstract updateY(): void;
    public abstract remove(): void;
    public abstract destroy(): void;
}
